<!-- TODO(ppt): [class.has-description]="config.description && !isCondensed" -->
<div class="condensed-body-wrapper" [ngClass]="!reportOptions().hideImages ? 'has-image' : 'hide-image'">
  <!-- REMOVE COL -->
  <div class="image-header">
    <!-- POSITION COL -->
    <div class="position">
      {{
      reportRecordData().data[0] && reportRecordData().data[0].position
      ? reportRecordData().data[0].position
      : reportRecordData().position
      }}.
    </div>
    <div class="record-actions print-hidden">
      <mat-icon class="green-close" color="y-icon" svgIcon="close-icon-grey" (click)="removeRecord.emit()"></mat-icon>
      <ng-container
        [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-goes-to-record'"
        [ngTemplateOutletContext]="{
          classes: '',
          urlParams: reportRecordData() | reportRecordRouteFn: { templateId: currentView().templateId, entity: entity() },
          content: goToIcon,
        }"
      ></ng-container>
      <ng-template #goToIcon>
        <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"></mat-icon>
      </ng-template>
    </div>
  </div>

  <!--   IMAGE COL -->
  @if (imageField && !reportOptions().hideImages) {
    <div class="image">
      <div
        miq-bg-image
        class="image-border"
        customPublishIconClass="custom-publish-icon-condensed"
        [ngClass]="{ 'no-border': reportOptions().hideImages }"
        [showImage]="!reportOptions().hideImages"
      [secureImage]="
        reportRecordData()
          | reportFieldFormatter
            : { templateId: currentView().templateId, field: imageField, joinString: true, onlyUrl: false, isPDF: isPDF() }
          | async
      "
      ></div>
    </div>
  }
  @if (templateProjectionMap() && (templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')) {
    <div
      class="subset-title"
      >
      <ng-container
        [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'"
        [ngTemplateOutletContext]="{ record: reportRecordData().data[0], reportItem: reportRecordData(), displayLabel: true }"
      ></ng-container>
    </div>
  }
  <div class="complete-row">
    <div class="data">
      <!-- ALL OTHER PROPS -->
      @for (subset of bodyGroupsLocal; track subset) {
        <div class="subsets">
          @if (subset && subset?.fields.length) {
            <ul>
              @for (field of subset.fields; track field) {
                <li (click)="emitEditableFields($event, field.id)">
                  <ng-container *ngTemplateOutlet="fieldRendering; context: { field: field }">></ng-container>
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  </div>

  <!-- ITEM DESCRIPTION -->
  @if (footerGroups() && footerGroups().length) {
    <div class="property-header-desc">
      @for (subset of footerGroups(); track subset) {
        <div class="property-header-desc-row">
          <ul>
            @if (subset.header != null) {
              <li>
                <label>{{ subset.header }}</label>
              </li>
            }
            @for (field of subset.fields; track field) {
              <li (click)="emitEditableFields($event, field.id)">
                <ng-container *ngTemplateOutlet="fieldRendering; context: { field: field }">></ng-container>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }
</div>

<ng-template #fieldRendering let-field="field">
  <!--
  TODO(ppt): for future contacts link requirements, routeFn and miq-goes-to-record
  component projection will be required on this template
  -->
  @if (!!field.label) {
    @if (field | displayField: reportRecordData().data[0]) {
      @if (
        reportRecordData()
        | isFieldVisible: { templateId: currentView().templateId, field: field, reportOptions: reportOptions() }
        ) {
        <label
          [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
          >{{ field.label }}</label
          >
        }
        @if (
          reportRecordData()
          | isFieldVisible: { templateId: currentView().templateId, field: field, reportOptions: reportOptions() }
          ) {
          <span
            class="{{ field.class }}"
            [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
            >
            {{
            reportRecordData()
            | reportFieldFormatter
            : {
            templateId: currentView().templateId,
            field: field,
            joinString: true,
            onlyUrl: false,
          }
          | async
          }}
        </span>
      }
    }
  } @else {
    <span
      class="{{ field.class }}"
      [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
      >{{
      reportRecordData()
      | reportFieldFormatter
      : {
      templateId: currentView().templateId,
      field: field,
      joinString: true,
      onlyUrl: false,
    }
    | async
    }}</span
    >
  }

</ng-template>
